import { BookingStatus } from '@/types';



export const GUIDE_ROUTES = {

  HOME: '/dashboard',

  BOOKINGS: '/dashboard/bookings',

  PAST_BOOKINGS: '/dashboard/bookings/past',

  PRICING: '/dashboard/pricing',

  AVAILABILITY: '/dashboard/availability',

  REVIEWS: '/dashboard/reviews',

  IDENTITY: '/dashboard/identity',

  REWARDS: '/dashboard/rewards',

  WALLET: '/dashboard/wallet',

  WALLET_TRANSACTIONS: '/dashboard/wallet/transactions',

  WALLET_WITHDRAW: '/dashboard/wallet/withdrawals',

  WALLET_BANK: '/dashboard/wallet/bank-accounts',

  bookingDetail: (id: string) => `/dashboard/bookings/${id}`,

} as const;



export const BOOKING_TAB_STATUS: Record<string, string | undefined> = {

  upcoming: BookingStatus.CONFIRMED,

  pending: BookingStatus.PAYMENT_PENDING,

  completed: BookingStatus.COMPLETED,

};



export type BookingTabKey = keyof typeof BOOKING_TAB_STATUS;

/** @deprecated Use BookingTabKey */
export type RequestTabKey = BookingTabKey;

/** @deprecated Use BOOKING_TAB_STATUS */
export const REQUEST_TAB_STATUS = BOOKING_TAB_STATUS;



/** @deprecated Use GUIDE_ROUTES.BOOKINGS */

export const GUIDE_ROUTES_LEGACY = {

  REQUESTS: '/dashboard/bookings',

};


